import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import pen from "../../../Components/assets/icons/pen.png";
import basket from "../../../Components/assets/icons/basket.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../../assets/icons/circle.png";
import rigth from "../../assets/icons/rigth.png";
import save from "../../assets/icons/save.png";
import cancel from "../../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Header/Header";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Offcanvas from "react-bootstrap/Offcanvas";

import toast, { Toaster } from "react-hot-toast";
import Card from "react-bootstrap/Card";
import Select from "react-select";
// import AddOffCanvance from "./Add";
// import EditOffCanvance from "./Edit";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Context } from "../../../utils/context";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import { Controller, useForm } from "react-hook-form";
import { postData } from "../../../utils/api";

library.add(fas);

// ********************************************************************************************************************************************************

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    getDownloadDataExcel,
    IMG_URL,
  } = useContext(Context);

  const [modalVehicleShow, setModalVehicleShow] = useState(false);
  const [selectedVehicleData, setSelectedVehicleData] = useState();
  const [selectedData, setSelectedData] = useState();
  const [modalEditShow, setModalEditShow] = useState(false);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [option, setOption] = useState();
  const [searchEmail, setSearchEmail] = useState("");
  const [searchContactNo, setSearchContactNo] = useState("");
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };
  const [changeStatus, setChangeStatus] = useState();

  const getDataAll = async () => {
    const response = await getData(
      `/employee/driver?page=${onPageChange}&per_page=${perPage}&term=${search}&searchEmail=${
        searchEmail || ""
      }&searchContactNo=${searchContactNo || ""}`
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    // setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    settotalPages(response?.data?.totalPages);
    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };
  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    reset,
    show,
    show1,
    searchEmail,
    search,
    searchContactNo,
    onPageChange,
  ]);

  const ChangeStatus = async (id, selectedOption) => {
    console.log(selectedOption, "selectedOption");

    try {
      const response = await postData(`/employee/driver/${id}`, {
        stage: selectedOption,
      });
      setChangeStatus(response);
    } catch (error) {
      console.error("Error changing status:", error);
      // Optionally, handle the error by updating the state or showing a message
    }
  };

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  // Delete module.....................................................
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  const DeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/employee/driver/${recordToDeleteId}`);
      await ErrorNotify(recordToDeleteName);
      setChangeStatus(response);
      setRecordToDeleteId(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
  };

  //toggle/
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          "/employee/driver/download",
          selectAllChecked,
          "Customers list"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useForm();
  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Driver"} link={"/employee/driver"} />
        <section className="AdvanceDashboard">
          <div className="col-xxl-12 col-xl-12 ">
            <div className="row MainRowsec">
              <section className="Tabels tab-radio tab-radio">
                <div className="">
                  {/* container */}
                  <div className="row">
                    <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                      {/* <div className="add">
                       
                        <Link
                          // to="/employee/employee_details/add"
                          type="button"
                          className="btn btn-add pe-3"
                        >
                          <div onClick={() => handleShow()}>
                            <img src={plus} className="plus me-2 ms-0" alt="" />
                            Add Employee
                          </div>
                        </Link>
                        
                      </div> */}

                      <div className="add">
                        <div className="dropdown">
                          <button
                            className="btn btn-columns dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src={colunms}
                              className="columns me-2 "
                              alt=""
                            />
                            Column Selection{" "}
                            <img src={top} className="top ms-1" alt="" />{" "}
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col1")}
                                href="#"
                              >
                                S. No
                                {visible?.col1 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col2")}
                                href="#"
                              >
                                Name
                                {visible?.col2 ? (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-4"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>
                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col3")}
                                href="#"
                              >
                                Customer Mobile
                                {visible?.col3 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>

                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col4")}
                                href="#"
                              >
                                Customer Email
                                {visible?.col4 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>

                            {/* <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col5")}
                                href="#"
                              >
                                Status
                                {visible?.col5 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li>

                            <li>
                              <Link
                                className="dropdown-item"
                                onClick={(event) => toggleColumn(event, "col6")}
                                href="#"
                              >
                                Action
                                {visible?.col6 ? (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye"
                                  />
                                ) : (
                                  <FontAwesomeIcon
                                    className="ms-2"
                                    icon="fa-solid fa-eye-slash"
                                  />
                                )}
                              </Link>
                            </li> */}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="border-line mt-3"></div>
                    <div className="row mt-4">
                      <div className="  col-lg-12 col-md-12 col-12">
                        <div className="d-flex mb-3 align-items-center">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => setperPage(e.target.value)}
                            >
                              {option?.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show  m-0">entries</p>
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 ">
                          <div className="sowing ms-3 me-2">
                            <p className="show  m-0">{`Showing ${Math.min(
                              (currentPage - 1) * perPage + 1
                            )} to ${Math.min(
                              currentPage * perPage,
                              data?.data?.totalEntries
                            )} of ${data?.data?.totalEntries} entries`}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12  col-md-12 col-12">
                        <div className="row">
                          {/* <div className="col-xxl-2 col-xl-2  col-lg-3  col-md-6 col-12 mt-md-0 mt-3">
                            <div className="num me-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Email"
                                id=""
                                value={searchEmail}
                                onChange={(e) => {
                                  setSearchEmail(e.target.value);
                                }}
                              />
                            </div>
                          </div> */}

                          {/* <div className="col-xxl-2 col-xl-2  col-lg-3  col-md-6 col-12 mt-md-0 mt-3">
                            <div className="num me-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Contact"
                                id=""
                                value={searchContactNo}
                                onChange={(e) => {
                                  setSearchContactNo(e.target.value);
                                }}
                              />
                            </div>
                          </div> */}
                          <div className="col-xxl-3 col-xl-4  col-lg-4  col-md-6 col-12 mb-2">
                            <div className="num me-2">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search Name"
                                id=""
                                value={search}
                                onChange={(e) => {
                                  setSearch(e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          {/* <div className="d-flex col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2">
                            <button
                              type="button"
                              className="btn btn-search w-100"
                              onClick={HandleDownload}
                            >
                              Download excel
                              <FontAwesomeIcon
                                icon="fa-solid fa-file-lines"
                                className="pdf-icon ms-3"
                                variant="success"
                              // className="btn btn-view"
                              />
                            </button>
                          </div> */}

                          <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2 col-12 mb-2">
                            <div className="Search-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setSearch("");
                                  // setSearchEmail("");
                                  // setSearchContactNo("");
                                  setReset(!reset);
                                }}
                                className="btn btn-reset w-100"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                          {/* </div> <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-2 col-12 mb-2"><div className="Search me-2">
                            <Button
                              type="button"
                              onClick={getDataAll}
                              className="btn btn-search"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div> */}
                        </div>{" "}
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr className="">
                            {visible.col0 && (
                              <th className="check round-check">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="selectAll"
                                    checked={
                                      allChecked.length ===
                                      selectAllChecked.length
                                    }
                                    onChange={handleChange}
                                    id="selectAll"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexCheckChecked"
                                  ></label>
                                </div>
                              </th>
                            )}
                            {visible.col1 && <th className="sr">S. No</th>}
                            {/* {visible.col2 && <th className="tax-name">Role</th>} */}
                            {visible.col2 && <th className="tax-name">Name</th>}

                            {visible.col3 && (
                              <th className="tax-name">Business Name</th>
                            )}
                            {visible.col4 && (
                              <th className="tax-name">Driver Email</th>
                            )}
                            {visible.col5 && (
                              <th className="tax-name">Driver Contact</th>
                            )}
                            {/* {visible.col8 && (
                              <th className="tax-name">Stage</th>
                            )} */}

                            {visible.col7 && (
                              <th className="tax-name">Driver Status</th>
                            )}
                            {visible.col6 && <th className="tax-name">View</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {/* {isAllow.includes(5) ? ( */}
                          {data?.data?.data?.map((d, index) => {
                            return (
                              <tr className="" key={index}>
                                {visible.col0 && (
                                  <td>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={d?.id}
                                        name="perselected"
                                        checked={selectAllChecked.includes(
                                          d?.id
                                        )}
                                        onChange={handleChange}
                                        id="flexCheckDefault"
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="flexCheckDefault"
                                      ></label>
                                    </div>
                                  </td>
                                )}
                                {visible.col1 && <td>{++index}.</td>}
                                {visible.col2 && <td>{d?.first_name}</td>}
                                {visible.col3 && <td>{d?.business_name}</td>}
                                {visible.col4 && <td>{d?.email}</td>}
                                {visible.col5 && <td>{d?.contact_no}</td>}
                                {/* {visible.col6 && (
                                  <td>
                                    {d?.id === 1 ? (
                                      <></>
                                    ) : (
                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          checked={d.status}
                                          onChange={() => {
                                            ChangeStatus(d.id);
                                          }}
                                          id={`flexSwitchCheckDefault${d?.id}`}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`flexSwitchCheckDefault${d?.id}`}
                                        >
                                          {d.status ? "Active" : "Inactive"}
                                        </label>
                                      </div>
                                    )}
                                  </td>
                                )} */}
                                {/* {visible.col5 && <td>{d?.stage}</td>} */}
                                {visible.col7 && (
                                  <td>
                                    {(d.stage ==="Approved" || d.stage ==="Rejected") && d?.stage}
                                    {d.stage==="Requested" &&<div className="main-form-section">
                                      <Form.Group>
                                        <Form.Label>Take an action</Form.Label>
                                        {errors?.stage && (
                                          <span className="text-danger">
                                            {errors.stage.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      <Form.Group controlId={`stage_${d.id}`}>
                                        <Controller
                                          name={`stage_${d.id}`}
                                          control={control}
                                          rules={{
                                            required: "Take an Action", // Validation rule
                                          }}
                                          render={({ field }) => (
                                            <Form.Select
                                              {...field} // Spread the controller field properties
                                              aria-label="Select an action"
                                              isInvalid={
                                                !!errors[`stage_${d.id}`]
                                              } // Highlight on validation error
                                              onChange={async (e) => {
                                                const selectedValue =
                                                  e.target.value;
                                                field.onChange(selectedValue); // Update the field value
                                                await ChangeStatus(
                                                  d.id,
                                                  selectedValue
                                                ); // Call your custom function
                                                setValue(`stage_${d.id}`, ""); // Reset the field after status change
                                              }}
                                            >
                                              <option value="">
                                                Select...
                                              </option>
                                              <option value="Approved">
                                                Approved
                                              </option>
                                              <option value="Rejected">
                                                Rejected
                                              </option>
                                            </Form.Select>
                                          )}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          {errors[`stage_${d.id}`]?.message}
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div> }
                                    
                                  </td>
                                )}
                                {visible.col6 && (
                                  <td>
                                    <>
                                      <Button
                                        variant="primary"
                                        onClick={() => {
                                          setSelectedData(d);
                                          setModalEditShow(true);
                                        }}
                                      >
                                        View All Data
                                      </Button>

                                      <Button
                                        variant="success"
                                        className="ms-2"
                                        onClick={() => {
                                          setSelectedVehicleData(d);
                                          setModalVehicleShow(true);
                                        }}
                                      >
                                        Vehicle Document
                                      </Button>
                                    </>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>

                      {modalEditShow && selectedData && (
                        <div
                          className="modal fade show"
                          style={{ display: "block" }}
                        >
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Driver Details</h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  onClick={() => setModalEditShow(false)}
                                ></button>
                              </div>
                              <div className="modal-body">
                                <p>
                                  <strong>Driving License Front </strong>{" "}
                                  {selectedData?.driver_document
                                    ?.driving_license_front && (
                                    <img
                                      src={
                                        IMG_URL +
                                        selectedData?.driver_document
                                          ?.driving_license_front
                                      }
                                      alt="Image"
                                      width="100"
                                      height="100"
                                    />
                                  )}
                                </p>
                                <p>
                                  <strong>Driving License back </strong>{" "}
                                  {selectedData?.driver_document
                                    ?.driving_license_back && (
                                    <img
                                      src={
                                        IMG_URL +
                                        selectedData?.driver_document
                                          ?.driving_license_back
                                      }
                                      alt="Image"
                                      width="100"
                                      height="100"
                                    />
                                  )}{" "}
                                </p>
                                <p>
                                  <strong>Aadhar Card Front</strong>{" "}
                                  {selectedData?.driver_document
                                    ?.aadhar_card_front && (
                                    <img
                                      src={
                                        IMG_URL +
                                        selectedData?.driver_document
                                          ?.aadhar_card_front
                                      }
                                      alt="Image"
                                      width="100"
                                      height="100"
                                    />
                                  )}{" "}
                                </p>
                                <p>
                                  <strong>Aadhar Card Back</strong>{" "}
                                  {selectedData?.driver_document
                                    ?.aadhar_card_back && (
                                    <img
                                      src={
                                        IMG_URL +
                                        selectedData?.driver_document
                                          ?.aadhar_card_back
                                      }
                                      alt="Image"
                                      width="100"
                                      height="100"
                                    />
                                  )}{" "}
                                </p>
                              </div>
                              <div className="modal-footer">
                                <button
                                  className="btn btn-secondary"
                                  onClick={() => setModalEditShow(false)}
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {modalVehicleShow && (
                        <div
                          className="modal fade show"
                          style={{ display: "block" }}
                        >
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  Customer Vehicle Details
                                </h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  onClick={() => setModalVehicleShow(false)}
                                ></button>
                              </div>
                              {selectedVehicleData?.driver_vehicles?.map(
                                (val) => (
                                  <div className="modal-body">
                                    <p>
                                      <strong>Vehicle Number:</strong>{" "}
                                      {val.vehicle_number}
                                    </p>
                                    <p>
                                      <strong>Description:</strong>{" "}
                                      {val.description}
                                    </p>
                                    <p>
                                      <strong>Cab Type:</strong>{" "}
                                      {val?.cab_type?.name}
                                    </p>
                                    <p>
                                      <strong>Fuel Type:</strong>{" "}
                                      {val?.fuel_type?.name}
                                    </p>
                                    <p>
                                      <strong>Car Front:</strong>{" "}
                                      {
                                        <img
                                          src={IMG_URL + val.car_front}
                                          alt="Image"
                                          width="100"
                                          height="100"
                                        />
                                      }{" "}
                                    </p>
                                    <p>
                                      <strong>Car Back:</strong>{" "}
                                      {
                                        <img
                                          src={IMG_URL + val.car_back}
                                          alt="Image"
                                          width="100"
                                          height="100"
                                        />
                                      }{" "}
                                    </p>
                                    <p>
                                      <strong>Car Left:</strong>{" "}
                                      {
                                        <img
                                          src={IMG_URL + val.car_left}
                                          alt="Image"
                                          width="100"
                                          height="100"
                                        />
                                      }{" "}
                                    </p>
                                    <p>
                                      <strong>Car Right:</strong>{" "}
                                      {
                                        <img
                                          src={IMG_URL + val.car_right}
                                          alt="Image"
                                          width="100"
                                          height="100"
                                        />
                                      }{" "}
                                    </p>
                                    <p>
                                      <strong>Car Interior Front:</strong>{" "}
                                      {
                                        <img
                                          src={IMG_URL + val.car_interior_front}
                                          alt="Image"
                                          width="100"
                                          height="100"
                                        />
                                      }{" "}
                                    </p>
                                    <p>
                                      <strong>Car Interior Back:</strong>{" "}
                                      {
                                        <img
                                          src={IMG_URL + val.car_interior_back}
                                          alt="Image"
                                          width="100"
                                          height="100"
                                        />
                                      }{" "}
                                    </p>
                                    <p>
                                      <strong>Rc Book Back:</strong>{" "}
                                      {
                                        <img
                                          src={IMG_URL + val.rc_book_back}
                                          alt="Image"
                                          width="100"
                                          height="100"
                                        />
                                      }{" "}
                                    </p>
                                    <p>
                                      <strong>Car Book Front:</strong>{" "}
                                      {
                                        <img
                                          src={IMG_URL + val.rc_book_front}
                                          alt="Image"
                                          width="100"
                                          height="100"
                                        />
                                      }{" "}
                                    </p>
                                  </div>
                                )
                              )}
                              <div className="modal-footer">
                                <button
                                  className="btn btn-secondary"
                                  onClick={() => setModalVehicleShow(false)}
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <Pagination_Holder
                        onPageChange={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {/* {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )} */}

      <Toaster position="top-right" />

      {/* <!-- Modal Delete --> */}
      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button className="btn btn-yes me-2" onClick={DeleteRecord}>
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tables;
